var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEpt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 29h-5v-4h-2v4h-6v-4h-2v4H6a1 1 0 0 0 0 2h20a1 1 0 0 0 0-2ZM26 1H6a5 5 0 0 0-5 5v12a5 5 0 0 0 5 5h20a5 5 0 0 0 5-5V6a5 5 0 0 0-5-5Zm1 9a1 1 0 0 1-2 0V8.36l-8.29 8.35A1 1 0 0 1 16 17a1 1 0 0 1-.71-.29L11 12.41l-4.36 4.3a1 1 0 0 1-1.41-1.42l5.07-5a1 1 0 0 1 1.41 0L16 14.58 23.53 7H22a1 1 0 0 1 0-2h4a1 1 0 0 1 1 1Z",
    fill: "#75b6e1",
    className: "fill-000000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEpt);
export default __webpack_public_path__ + "static/media/ept.7d570c556e21a0f71bce6a0ff4bd3288.svg";
export { ForwardRef as ReactComponent };